export const mouseMoveScroll = {
    data(){
        return {
            classScrollElementMouseMove: '',
            scrollElementMouseMove: '',
            isMouseDownScrollElement: false,
        }
    },
    mounted() {
        this.scrollElementMouseMove = document.querySelector(this.classScrollElementMouseMove);
        if(this.scrollElementMouseMove){
            this.scrollElementMouseMove.addEventListener('mousemove', this.mouseMoveScrollElement);
            this.scrollElementMouseMove.addEventListener('mousedown', this.mouseDownScrollElement);
            this.scrollElementMouseMove.addEventListener('mouseup', this.mouseUpScrollElement);
            this.scrollElementMouseMove.addEventListener('mouseleave', this.mouseLeaveScrollElement);
        }
    },
    unmounted() {
        if(this.scrollElementMouseMove){
            this.scrollElementMouseMove.removeEventListener('mousemove', this.mouseMoveScrollElement);
            this.scrollElementMouseMove.addEventListener('mousedown', this.mouseDownScrollElement);
            this.scrollElementMouseMove.addEventListener('mouseup', this.mouseUpScrollElement);
            this.scrollElementMouseMove.addEventListener('mouseleave', this.mouseLeaveScrollElement);
        }
    },
	methods: {
        mouseMoveScrollElement(event) {
            event.preventDefault();
            if(!this.isMouseDownScrollElement) {
                return;
            }
            let scrollSpeed = 2;
            this.scrollElementMouseMove.scrollLeft -= (event.movementX * scrollSpeed);
		},
        mouseDownScrollElement(event){
            this.isMouseDownScrollElement = true;
        },
        mouseUpScrollElement(event){
            this.isMouseDownScrollElement = false;
        },
        mouseLeaveScrollElement(event){
            this.isMouseDownScrollElement = false;
        },
	},
}
